// Email validation regex
export const emailRegex =
	"^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$";
// UK phone number validation string
export const phoneRegex =
	"^(((+44\\s?\\d{4}|(0\\d{4})?)\\s?\\d{3}s?\\d{3})|((+44\\s?\\d{3}|(0\\d{3})?)\\s?\\d{3}s?\\d{4})|((+44\\s?\\d{2}|(0\\d{2})?)\\s?\\d{4}\\s?\\d{4}))(\\s?#(\\d{4}|\\d{3}))?$";
